<template>
  <div class="entity team">
    <sui-form-field v-if="visibleFields.account">
      <label>Account</label>
      <sui-dropdown class="disabled" selection search>
        <Logo :src="account.avatar" :email="account.email" square inline />{{account.name}}
      </sui-dropdown>
    </sui-form-field>
    <sui-form-fields>
      <EntityInput v-model="entity.email" fieldName="email" ref="email" v-if="visibleFields.email" />
      <EntityInput v-model="entity.name" fieldName="name" ref="name" v-if="visibleFields.name" />
    </sui-form-fields>
    <sui-form-fields>
      <EntityDropdown :width="6" :options="rolesList" v-model="entity.role" fieldName="role" ref="role" :placeholder="rolePlaceholder" v-if="visibleFields.role" />
      <MemberExpiration v-model="entity.expiration" fieldName="expiration" ref="expiration" v-if="visibleFields.expiration" />
    </sui-form-fields>
    <EntityActions v-model="entity.actions" fieldName="actions" ref="actions" v-if="visibleFields.actions" />
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import FormEntity from '@/mixins/FormEntity'
  import EntityInput from '@/components/forms/EntityInput'
  import EntityDropdown from '@/components/forms/EntityDropdown'
  import MemberExpiration from '@/components/forms/MemberExpiration'
  import EntityActions from '@/components/forms/EntityActions'

  export default {
    name: 'FormMember',
    mixins: [
      FormEntity,
    ],
    components: {
      EntityActions,
      EntityInput,
      EntityDropdown,
      MemberExpiration,
    },
    data() {
      return {
        object: 'Member',
        commonFields: ['name'],
      }
    },
    computed: {
      ...mapGetters(['account', 'roles']),
      rolePlaceholder() {
        return this.roles.length ? 'Select role...' : 'No roles'
      },
      rolesList() {
        const rolesList = this.roles.map(role => {
          return {
            value: role.id,
            text: role.name,
          }
        })
        rolesList.unshift({value: '', text: 'No role'})
        return rolesList
      },
    }
  }
</script>
